import {
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Icon,
  Switch,
  Typography
} from '@material-ui/core';
import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { Formik } from 'formik';

// local imports
import { CampaignService } from 'app/services';
import { useStateCallback } from 'app/hooks';
import { useNotCampaignPharmaciesService, useQuery } from 'app/hooks/services';
import { EnvDefaults } from 'app/utils';
import { FilterCampaignPharmacies } from 'app/components/organisms/filter-forms';
import { CustomDataTable } from 'app/components/organisms/table';
import { AsyncButton } from 'app/components/atoms';

const tableQueries = {
  limit: 25,
  skip: 0,
  city_id: '',
  district_id: '',
  filter: ''
};

const AddPharmacyModal = ({
  campaignId,
  setPharmacyIds,
  pharmacyIds,
  confirmBtnDisabled,
  modal
}) => {
  const history = useHistory();
  const [loading, setLoading] = useStateCallback(false);

  const handleAddPharmacies = obj => {
    if (obj.length > 0) {
      const ids = obj.map(it => it.id);
      setPharmacyIds(prev => ({ ...prev, pharmacy_ids: ids }));
    } else setPharmacyIds(prev => ({ ...prev, pharmacy_ids: [] }));
  };

  // toggle all pharmacies
  const handleChange = evt => {
    setPharmacyIds(state => ({
      ...state,
      is_all_turp_pharmacies: evt.target.checked
    }));
  };

  // autocomplete filter input related funcs.
  const handleAutocomplete = (e, name) => {
    if (e) {
      setQueries(prevState => ({
        ...prevState,
        skip: 0,
        [name]: e.value
      }));
    } else {
      setQueries(prevState => ({
        ...prevState,
        skip: 0,
        [name]: ''
      }));
    }
  };

  // handle add pharmacies
  const handleAddPharmacy = useCallback(async () => {
    setLoading(true, async () => {
      try {
        await CampaignService.addCampaignToPharmacies(campaignId, pharmacyIds);
        setTimeout(() => {
          history.push('/campaign-management/');
        }, 2000);
      } catch (err) {
        console.log('Error -> ', err);
      } finally {
        setLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLoading, campaignId, pharmacyIds]);

  // service connection hooks
  const { queries, isFilteringRef, handleFilterChange, handlePageChange, handleSort, setQueries } =
    useQuery(tableQueries);
  const { service, handleRefresh } = useNotCampaignPharmaciesService(
    campaignId,
    queries,
    isFilteringRef
  );

  return (
    <>
      <Card className="mb-16" elevation={4}>
        <CardContent>
          <Typography className="font-semibold text-14 text-gray-800">Kampanya Kapsamı</Typography>
          <FormControlLabel
            control={<Switch onChange={handleChange} />}
            label="Tüm Turp Eczaneleri"
          />
        </CardContent>
      </Card>

      <Card elevation={4} className="mb-16">
        <CardContent>
          <div className="mb-16">
            <div className="flex items-center">
              <Icon>filter_list</Icon>

              <Typography variant="subtitle1" className="text-gray-700 font-semibold mx-8">
                Filtrele
              </Typography>

              {isFilteringRef.current && (
                <CircularProgress color="secondary" size={22} thickness={6} />
              )}
            </div>

            <Formik initialValues={EnvDefaults.filterCampaignPharmaciesAddDefaults}>
              <FilterCampaignPharmacies
                modal
                handleChange={handleFilterChange}
                handleFilterAutoComplete={handleAutocomplete}
              />
            </Formik>
          </div>
        </CardContent>
      </Card>

      <Card elevation={4}>
        <CardContent>
          <CustomDataTable
            selectRow={handleAddPharmacies}
            selectableRows={!pharmacyIds.is_all_turp_pharmacies}
            defaultSortId={queries?.orderBy}
            defaultDirection={queries?.sortBy}
            service={service}
            queries={queries}
            handlePageChange={handlePageChange}
            handleChange={handleFilterChange}
            handleSort={handleSort}
            handleRefreshTable={handleRefresh}
          />

          {!modal && (
            <div className="flex justify-end mt-16">
              <AsyncButton
                text="Eczane Ekle"
                color="secondary"
                loading={loading}
                handleClick={handleAddPharmacy}
                className=""
                disabled={confirmBtnDisabled}
              />
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default AddPharmacyModal;
